import type { TFunction } from 'i18next'

/**
 * Значение параметра тарифа человеческим языком.
 *
 * `-1` внутри означает «без ограничений», но учитель на странице тарифов читал
 * его как минус один: «Максимум программ: -1».
 */
export function formatPlanParameterValue(t: TFunction, value: string): string {
  if (value === 'true') return t('common.yes')
  if (value === 'false') return t('common.no')
  if (value.trim() === '-1') return t('subscription.unlimited')

  return value
}

/**
 * Срок действия плана.
 *
 * Сервер отдаёт готовую строку вида «12 month» — непереведённую и без
 * склонения. Собираем подпись сами из `period` и `interval`, а серверную строку
 * держим запасным вариантом на случай незнакомой единицы.
 */
export function formatPlanDuration(
  t: TFunction,
  period: number | undefined,
  interval: string | undefined,
  fallback?: string,
): string {
  const known = ['day', 'week', 'month', 'year']
  if (typeof period !== 'number' || !interval || !known.includes(interval)) {
    return fallback ?? ''
  }

  return t(`subscription.duration.${interval}`, { count: period })
}
